import { CurrencyValue } from '@dfl/mui-react-common';
import { TypographyProps } from '@mui/material';
import { memo } from 'react';

type PercentValueProps = TypographyProps & {
  value: number | string;
  symbol?: string;
};

const PercentValue = ({ value, symbol = '%', ...props }: PercentValueProps) => {
  return <CurrencyValue value={value} currency={symbol} {...props} />;
};

export default memo(PercentValue);
